import './Footer.less';

export const prefix = 'oc-c-footer';

export { default } from './Footer';

